<template>
  <div class="settingsAreaIntegrations">
    <!-- Google Calendar -->
    <SettingsSectionIntegration v-for="(integration, index) in integrations" :key="index" :integration="integration" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import SettingsSectionIntegration from "./SettingsSectionIntegration.vue";
import SettingsAPI from "./SettingsAPI";
import SettingsConstants from "./SettingsConstants";

export default {
  name: "Integrations",
  components: {
    SettingsSectionIntegration,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    integrations: () => SettingsConstants.integrations,
  },
  async mounted() {
    await SettingsAPI.getGoogleCalAuthState(this.user._id);
  },
};
</script>
